import { parseDate } from './dates';
import type { PostSummary } from '$lib/types';

export interface YearGroup<T extends PostSummary = PostSummary> {
	year: string;
	posts: T[];
}

export function groupPostsByYear<T extends PostSummary>(posts: T[]): YearGroup<T>[] {
	const groups = new Map<string, T[]>();

	for (const post of posts) {
		const year = post.date ? String(parseDate(post.date).getFullYear()) : 'Undated';
		const list = groups.get(year);

		if (list) {
			list.push(post);
		} else {
			groups.set(year, [post]);
		}
	}

	return [...groups.entries()].map(([year, grouped]) => ({ year, posts: grouped }));
}
